import { EtiketbasPage } from './../etiketbas/etiketbas';
import { BllKategoriler } from './../../../providers/bll/bll-kategoriler';
import { StokHareketleriPage } from './../stok-hareketleri/stok-hareketleri';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { StokDetayPage } from './../stok-detay/stok-detay';
import { StokResimEkleGuncellePage } from './../stok-resim-ekle-guncelle/stok-resim-ekle-guncelle';
import { BllViewStoklar } from './../../../providers/bll/bll-ViewStoklar';
import { SayimGirisiPage } from './../sayim-girisi/sayim-girisi';
import { Ortak } from './../../../providers/ortak';
import { StokeklePage } from './../stokekle/stokekle';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Searchbar } from 'ionic-angular';
import { BllOrtak } from '../../../providers/bll/bll-ortak';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { ActionSheetController } from 'ionic-angular'
import { TopluFiyatDegistirPage } from '../toplu-fiyat-degistir/toplu-fiyat-degistir';




@Component({
  selector: 'page-stoklar',
  templateUrl: 'stoklar.html',
})
export class StoklarPage {
  @ViewChild('sideNavUrunAra') sideNav;
  @ViewChild('searchbar') searchbar: Searchbar;
  aranan: string = "";
  take: number = 0;
  UrunListesi = [];
  KategoriListesi = [];
  secilenkategoriID: number = -1;

  kullaniciyetki: any;
  etiketid: any = { Id: -1, StokKartiID: "", StokAdi: "" };
  etiketkontrol: number = 0;
  yaziciadi: any;
  param: any = { KullaniciSayimYapabilsinMi: "" };
  constructor(private barcodeScanner: BarcodeScanner,
    public navCtrl: NavController,
    public actionSheetCtrl: ActionSheetController,
    public ortak: Ortak,
    public modalCtrl: ModalController,
    public bllOrtak: BllOrtak,
    public navParams: NavParams) {
    this.yaziciadi = this.ortak.StAyarGetir.FisYaziciAdi;
    this.kullaniciyetki = this.ortak.storagePersonelGetir.Type;
  }

  ionViewDidLoad() {
    this.closeNav();
    this.UrunAra();
    this.parametreleriGetir();
    this.KategoriGetir();
  }
  ionViewDidEnter() {
    setTimeout(() => {
      this.searchbar.setFocus();
    });
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {

    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
    this.searchbar.setFocus();

  }

  KategoriGetir() {
    var kategoriler = new BllKategoriler();
    kategoriler.getAllWithSpecificQuery("(replace(replace(replace(replace(replace(replace(replace(KategoriAdi,'İ','i'),'Ö','ö'),'Ç','ç'),'I','ı'),'Ğ','ğ'),'Ü','ü'),'Ş','ş') like '%" + "" + "%' or KategoriAdi='" + "" + "')" + " order by Sort").then(a => {
      var sonuc = <any>a;
      this.KategoriListesi = sonuc;
      if (this.KategoriListesi == null || this.KategoriListesi.length == 0) {
        var formData = new FormData();
        formData.append("aranan", "");

        this.bllOrtak.islem(formData, "KategoriListesi", "", false).then(a => {
          var sonuc = <any>a;
          this.KategoriListesi = sonuc.SonucObject;
          
        })
      }
      this.searchbar.setFocus();
    });
  

  }
  parametreleriGetir() {
    this.bllOrtak.islemWithoutPost("ParametreleriVer", "", false).then(a => {
      var sonuc = <any>a;
      this.param = sonuc.SonucObject;

    })
  }

  UrunAra() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("katid", this.secilenkategoriID.toString());
    formData.append("take", this.ortak.StAyarGetir.MalzemeListeSayisi.toString());
    this.bllOrtak.islem(formData, "Stoklar", "Ürünler Getiriliyor", true).then(a => {
      var sonuc = <any>a;
      console.log(sonuc)
      this.UrunListesi = sonuc.SonucObject;
      
      this.closeNav();
      this.searchbar.setFocus();
    }).catch(x=>
      {
        console.log(x);
      })
  }

  OfflineStokGetir() {
    var bllViewStoklar = new BllViewStoklar();
    bllViewStoklar.getAllWithSpecificQuery("(replace(replace(replace(replace(replace(replace(replace(StokAdi,'İ','i'),'Ö','ö'),'Ç','ç'),'I','ı'),'Ğ','ğ'),'Ü','ü'),'Ş','ş') like '%" + this.aranan + "%' or Barcode1='" + this.aranan + "')" + " order by ID").then(a => {
      this.UrunListesi = a;
      if (this.UrunListesi.length == 0) {
        this.UrunAra();
      }
    });
  }

  urunler(e) {

    if (e.keyCode == 13) {
      this.UrunAra();
    }
  }


  barkodOkut() {
    this.barcodeScanner.scan().then(a => {
      var sonuc = <any>a;
      this.aranan = sonuc.text;
      this.UrunAra();
    })
  }
  TopluEtiketBas() {
    this.navCtrl.push(EtiketbasPage);
  }
  yeni() {
    let modal = this.modalCtrl.create(StokeklePage, "", { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  StokSil(urun) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      formData.append("LogicalRef", urun.ID);
      this.bllOrtak.islem(formData, "StokSil", "", true).then(a => {
      });
      this.UrunAra();
    })
  }
  StokGuncelle(Stok) {
    if (this.kullaniciyetki == 2) {
      let modal = this.modalCtrl.create(StokeklePage, { vwUrun: Stok }, { cssClass: "genisekran" });
      modal.onDidDismiss(data => {
        this.ionViewDidLoad();
      });
      modal.present();
    }


    else {
      if (this.param.KullanisiStokEdit == 1) {
        let modal = this.modalCtrl.create(StokeklePage, { vwUrun: Stok }, { cssClass: "genisekran" });
        modal.onDidDismiss(data => {
          this.ionViewDidLoad();
        });
        modal.present();
      }
      else {
        this.ortak.showBasicAlert("Uyarı", "Bu işlemi yapmaya yetkiniz yok lütfen yöneticinize başvurunuz");
      }

    }

  }
  toplufiyatdegistir() {
    this.navCtrl.push(TopluFiyatDegistirPage);
  }
  pageIslemler() {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'İşlemler',
      buttons: [
        {
          text: 'Toplu Fiyat Değiştir ',

          handler: () => {
            this.toplufiyatdegistir();
          }

        },
        {
          text: 'Toplu Etiket Bas ',

          handler: () => {
            this.TopluEtiketBas();
          }

        },


        {
          text: 'Stok Kartı Ekle',

          handler: () => {
            this.yeni();
          }

        },

        {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }
  SayimGirisi(Stok) {
    if (this.kullaniciyetki == 2) {
      let modal = this.modalCtrl.create(SayimGirisiPage, { vwUrun: Stok });
      modal.onDidDismiss(data => {
        this.ionViewDidLoad();
      });
      modal.present();

    }

    else {
      if (this.param.KullaniciSayimYapabilsinMi == 1) {
        let modal = this.modalCtrl.create(SayimGirisiPage, { vwUrun: Stok });
        modal.onDidDismiss(data => {
          this.ionViewDidLoad();
        });
        modal.present();
      }
      else {
        this.ortak.showBasicAlert("Uyarı", "Bu işlemi yapmaya yetkiniz yok lütfen yöneticinize başvurunuz");
      }

    }

  }
  barkodara() {
    this.barcodeScanner.scan().then(barcodeData => {

    }).catch(err => {

    });
  }
  resimEkleGuncelle(Stok) {
    let modal = this.modalCtrl.create(StokResimEkleGuncellePage, { stok: Stok });
    modal.present();
  }
  stokdetay(Stok) {
    let modal = this.modalCtrl.create(StokDetayPage, { stok: Stok });
    modal.present();
  }
  stokhareketleri(Stok) {
    let modal = this.modalCtrl.create(StokHareketleriPage, { stok: Stok });
    modal.present();
  }
  varyantekle(Stok)
  {
    let modal=this.modalCtrl.create(StokeklePage,{varyant:Stok});
    modal.present();
  }
  Islemler(Stok) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Stok  İşlemleri',
      buttons: [
        {
          text: 'Resim Ekle',

          handler: () => {
            this.resimEkleGuncelle(Stok);
          }

        },

        {
          text: 'Etiket Bas',

          handler: () => {
            this.etiketgonder(Stok);
          }

        },
        {
          text: 'Stok Hareketleri',

          handler: () => {
            this.stokhareketleri(Stok);
          }

        },
        {
          text: 'Sayım Girişi',

          handler: () => {
            this.SayimGirisi(Stok);
          }

        },
       {
          text: 'Düzenle',
          handler: () => {
            this.StokGuncelle(Stok);
          }
        }, {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }
  etiketgonder(Stok) {

    this.ortak.showConfirmAlert("Uyarı", "Etiket Basıma Gönderilecek. Devam etmek istiyor musunuz?").then(k => {

      var formData = new FormData();
      formData.append("stokid", Stok.ID.toString());
      formData.append("yaziciadi", this.yaziciadi);
      this.bllOrtak.etiketbas(formData, "RafEtiketiBasTekli", "", true).then(a => {
        var sonuc = <any>a;

        if (sonuc.Sonuc == 1) {
          this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        }

        if (sonuc.Sonuc == 99) console.log("err", sonuc.SonucObject);
      }).catch(x => {
        console.log(x);
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/stoklar/stoklar.ts